'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var max = _interopDefault(require('ml-array-max'));
var sum = _interopDefault(require('ml-array-sum'));

/**
 * Computes the norm of the given values
 * @param {Array<number>} input
 * @param {object} [options={}]
 * @param {string} [options.algorithm='absolute'] absolute, sum or max
 * @return {number}
 */
function norm(input, options = {}) {
  const { algorithm = 'absolute' } = options;
  if (!Array.isArray(input)) {
    throw new Error('input must be an array');
  }

  if (input.length === 0) {
    throw new Error('input must not be empty');
  }

  switch (algorithm.toLowerCase()) {
    case 'absolute': {
      let absoluteSumValue = absoluteSum(input);
      if (absoluteSumValue === 0) return input.slice(0);
      return input.map((element) => element / absoluteSumValue);
    }
    case 'max': {
      let maxValue = max(input);
      if (maxValue === 0) return input.slice(0);
      return input.map((element) => element / maxValue);
    }
    case 'sum': {
      let sumValue = sum(input);
      if (sumValue === 0) return input.slice(0);
      return input.map((element) => element / sumValue);
    }

    default:
      throw new Error(`norm: unknown algorithm: ${algorithm}`);
  }
}

function absoluteSum(input) {
  let sumValue = 0;
  for (let i = 0; i < input.length; i++) {
    sumValue += Math.abs(input[i]);
  }
  return sumValue;
}

module.exports = norm;
